import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChange,
    SimpleChanges,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { v4 as uuid } from 'uuid';
import * as _ from 'lodash-es';

@Component({
    selector: 'income-type',
    templateUrl: './income-type.component.html',
    styleUrls: ['./income-type.component.scss'],
    standalone: false
})
export class IncomeTypeComponent implements OnInit {
    /**
     * UUI to identify controls when multiple deployed
     * @type {string}
     * @memberof IncomeTypeComponent
     */
    instanceId: string;

    /**
     * Control for the radio buttons
     * @type {FormControl}
     * @memberof IncomeTypeComponent
     */
    radioControlIncomeType: UntypedFormControl = new UntypedFormControl(null, [
        Validators.required,
        Validators.min(1),
    ]);

    /**
     * Control for the select list
     * @type {FormControl}
     * @memberof IncomeTypeComponent
     */
    selectControlIncomeType: UntypedFormControl = new UntypedFormControl(null, [
        Validators.required,
        Validators.min(1),
    ]);

    /**
     *
     *
     * @type {boolean}
     * @memberof IncomeTypeComponent
     */
    @Input() invalid: boolean = false;

    /**
     *
     *
     * @type {boolean}
     * @memberof IncomeTypeComponent
     */
    @Input() isInvestmentExist: boolean = false;

    /**
     *
     *
     * @type {boolean}
     * @memberof IncomeTypeComponent
     */
    @Input() isRentalExist: boolean = false;

    /**
     * FormGroup for the controls
     *
     * @type {FormGroup}
     * @memberof IncomeTypeComponent
     */
    formIncomeType: UntypedFormGroup;

    types: Object[] = [
        { value: 1, label: 'Full time employment' },
        { value: 2, label: 'Part time employment' },
        { value: 3, label: 'Self-employment' },
        { value: 5, label: 'Pension' },
        { value: 7, label: 'Investments' },
        { value: 4, label: 'In receipt of state benefits' },
        { value: 8, label: 'Rental income' },
        { value: 6, label: 'I\'m currently unemployed' },
    ];

    /**
     * Inoming form control containing income type
     * @type {FormControl}
     * @memberof IncomeTypeComponent
     */
    @Input() incomeType: UntypedFormControl = new UntypedFormControl(null, []);

    /**
     * Event emitting the output formcontrol
     * @type {EventEmitter}
     * @memberof IncomeTypeComponent
     */
    @Output() incomeTypeChange: EventEmitter<UntypedFormControl> = new EventEmitter<UntypedFormControl>();

    /**
     * Creates an instance of IncomeTypeComponent.
     * @param {FormBuilder} fb
     * @memberof IncomeTypeComponent
     */
    constructor(private fb: UntypedFormBuilder) {
        this.formIncomeType = fb.group({
            selectControlIncomeType: this.selectControlIncomeType,
            radioControlIncomeType: this.radioControlIncomeType,
        });
    }


    ngOnChanges(changes: SimpleChanges) {
        const change: SimpleChange = changes['incomeType'];

        // If tis' not income type changing, don't care.
        if (_.isNil(change)) {
            return;
        }

        // Get the control.
        const ctrl = change.currentValue as UntypedFormControl;

        // Is the control new? The parent populates this.
        const isNew = ctrl.parent.get('tadIsNew').value;

        // Set child component changes.
        this.formIncomeType.get('selectControlIncomeType').setValue(ctrl.value);
        this.formIncomeType.get('radioControlIncomeType').setValue(ctrl.value);

        if (!isNew) {
            this.formIncomeType.get('selectControlIncomeType').disable();
            this.formIncomeType.get('radioControlIncomeType').disable();
        }
    }

    /**
     * Because statusChanges doesn't track touched for selects, we need to track it ourselves.
     *
     * @param {any} event
     * @memberof IncomeTypeComponent
     */
    incomeTypeTouched(event) {
        const radio = this.radioControlIncomeType;
        const select = this.selectControlIncomeType;

        if (event === 'radio' && radio.untouched) {
            this.radioControlIncomeType.markAsTouched();
            this.incomeTypeChange.emit(this.radioControlIncomeType);
        }
        if (event === 'select' && select.untouched) {
            this.selectControlIncomeType.markAsTouched();
            this.incomeTypeChange.emit(this.selectControlIncomeType);
        }
    }

    populateFieldValues() {
        this.selectControlIncomeType.setValue(this.incomeType.value);
        this.radioControlIncomeType.setValue(this.incomeType.value);
    }

    /**
     * Initialise component
     * @memberof IncomeTypeComponent
     */
    ngOnInit() {
        this.instanceId = uuid();
        this.onChanges();
        this.populateFieldValues();
    }

    /**
     * Track changes in the form controls
     * @memberof IncomeTypeComponent
     */
    onChanges(): void {
        if (this.isInvestmentExist) {
            this.types = this.types.filter(x => x['value'] !== 7);
        }
        if (this.isRentalExist) {
            this.types = this.types.filter(x => x['value'] !== 8);
        }
        this.formIncomeType.get('radioControlIncomeType').valueChanges.subscribe((val) => {
            if (this.formIncomeType.get('selectControlIncomeType').value !== val) {
                this.formIncomeType.get('selectControlIncomeType').setValue(val);
                this.incomeTypeChange.emit(this.radioControlIncomeType);
            }
        });
        this.formIncomeType.get('selectControlIncomeType').valueChanges.subscribe((val) => {
            if (this.formIncomeType.get('radioControlIncomeType').value !== val) {
                this.formIncomeType.get('radioControlIncomeType').setValue(val);
                this.incomeTypeChange.emit(this.selectControlIncomeType);
            }
        });
    }
}
